import { AppConfig } from '../../app.config';
import { Lease } from '../../gql/graphql';
import { getUnifiedToken } from './cookie.helper';

const unifiedUrlRegex = /epply.+koalafi\.com/;

export const transferToItemManagement = (lease: Lease) => {
  window.location.href = `${AppConfig.dealerPortalUrl}/PurchasedArticlesForm/Index?publicId=${lease.publicId}`;
};

// OR-2278: replaces the old getTargetUi()/UiType enum, which also distinguished Loans and Rapid
// targets — both decommissioned. The only remaining callers just checked `=== UiType.Unified`.
// No token at all (the common case — most customers never went through a Loans/Rapid handoff)
// still defaults to true, matching getTargetUi()'s old default.
export const isUnified = (): boolean => {
  const unifiedToken = getUnifiedToken();
  return !unifiedToken || unifiedUrlRegex.test(unifiedToken.targetUi);
};
